import { useState } from 'react';
import axios from 'axios';

/**
 * Hook for downloading collection request cards.
 * Handles the download process including file name extraction and blob creation.
 */
export const useDownloadCard = () => {
  const [downloadingCardId, setDownloadingCardId] = useState<string | null>(null);

  const downloadCard = async (collectionRequestId: string) => {
    setDownloadingCardId(collectionRequestId);
    try {
      const response = await axios({
        method: 'post',
        url: '/api/card/download',
        data: { collectionRequestId },
        responseType: 'blob',
      });

      const contentDispositionHeader = response.headers['content-disposition'];
      let fileName = 'card.docx';

      if (contentDispositionHeader) {
        const fileNameMatch = contentDispositionHeader.match(/filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/);
        if (fileNameMatch && fileNameMatch.length > 1) {
          fileName = decodeURIComponent(fileNameMatch[1]);
        }
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading card:', error);
      throw error;
    } finally {
      setDownloadingCardId(null);
    }
  };

  return {
    downloadCard,
    downloadingCardId,
    isDownloading: (collectionRequestId: string) => downloadingCardId === collectionRequestId,
  };
};
